// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 957 ? "routes" : chunkId) + "-legacy." + {"244":"cea70d57","871":"74a5aa7f","957":"e13e2030"}[chunkId] + ".js";
};